// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$donorListApiService = {
      donor_list_api_url: `${process.env.VUE_APP_EPAPER_API_URL}/donor-lists`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.donor_list_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 根據年份和月份取得捐款名單
       * @param {string} year - 年份
       * @param {string} month - 月份
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getByYearAndMonth(year, month, additional = '') {
        const url = `${this.donor_list_api_url}?filter[of_year]=${year}&filter[of_month]=${month}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && response.data.data.length > 0
          ? response.data.data[0]
          : null
      },

      /**
       * 取得年份清單
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getListOfYear() {
        const response = await axios.get(`${this.donor_list_api_url}/year`)
        return response.data
      }
    }
  }
}
